import { route } from 'preact-router';
import { useEffect } from 'preact/hooks';
import { type ImpersonationContext, useAuth } from '../context/AuthContext.js';
import { api } from '../services/api.js';

/**
 * 036 US1 — the admin panel opens the user app here with a single-use handoff
 * code. We exchange it for an impersonation token + context, adopt the session
 * (the app then acts as the target), and land on the home screen.
 */
export function ImpersonateExchangePage(_props: { path?: string }) {
  const { enterImpersonation } = useAuth();

  // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only code exchange
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) {
      route('/');
      return;
    }
    api
      .post<{ access_token: string; impersonation: ImpersonationContext }>(
        '/auth/impersonate/exchange',
        { code },
      )
      .then(async (res) => {
        await enterImpersonation(res.access_token, res.impersonation);
        route('/');
      })
      .catch(() => route('/account/login'));
  }, []);

  return (
    // 138: this screen's former `min-h-screen` stacked a second full viewport height under the
    // shell's own `pb-20` reserve — the defect 134 removed from twelve other screens and missed
    // here. Bounded rather than plain-removed, because `items-center justify-center` needs a
    // height to centre within.
    //
    // 138 follow-up: `dvh` outright, not `calc(100dvh-132px)`. `/impersonate` is now excluded
    // from `showNav`, so the shell reserves no bell row and no bottom-nav clearance on this
    // route and the whole viewport is what is left. While it was still subtracting the 132px
    // constant, the message measured 66px above centre live — the reserve was 132px on paper and
    // 80px in fact, since the bell needs the very session this screen is still acquiring.
    <div class="page-fill bg-bg flex items-center justify-center">
      <p class="text-gray-400">Entering impersonation…</p>
    </div>
  );
}
